import GeoPoint from "../Shared/GeoPoint";
import JobWorkerInterviewType from "./JobWorkerInterviewType";

export default class JobInterviewSummaryDto {
    workerFullName = '';
    contactFullName = '';
    startAt: Date = new Date();
    endAt: Date = new Date();
	type: JobWorkerInterviewType = JobWorkerInterviewType.Undefined;
    instructions = '';
    fullAddress = '';
    buildingNameNumber = '';
    streetRoadBlock = '';
    locality = '';
    cityTown = '';
    stateProvinceRegion = '';
    postZipCode = '';
    countryCode = '';
    geometry: GeoPoint = new GeoPoint();
    isExactGeo: boolean;

}